<template>
  <hm-select ref="guestSearch"
             v-model.trim="internalValue"
             :id="$attrs['id']"
             :autocomplete-url="serviceUrls.guest.find(this)"
             :label="label"
             :name="name || 'guestsearch'"
             :disabled="disabledCombined"
             :help="help"
             :cols="cols"
             :taggable="true"
             :taggable-existing-value="true"
             label-expression="${option.name} (#${option.number})"
             @option:created="onCreateOption($event)">
    <template slot="option" slot-scope="props">
      <table v-if="!isEmpty(props.option.number)">
        <tr>
          <td class="td--gravatar">
            <gravatar :hash="props.option.gravatar" :type="props.option.type" :gender="props.option.gender" />
          </td>
          <td style="vertical-align: top;padding-left:1rem;">
            <b class="privacy--blur">{{ props.option.name }}</b> (#{{ props.option.number }})<br>
            <span v-if="!isEmpty(props.option.email)" class="privacy--blur">{{ props.option.email }}<br></span>
            <span v-if="!isEmpty(props.option.address) && props.option.address.trim() !== ',' " class="privacy--blur">{{ optimizeAddress(props.option.address) }}<br></span>
            <span v-if="!isEmpty(props.option.birthDate) && props.option.birthDate !== '1900'">{{ props.option.birthDate }}</span>
          </td>
        </tr>
      </table>
      <table v-else>
        <tr>
          <td class="td--gravatar td--gravatar--empty"></td>
          <td style="vertical-align: top;padding-left:1rem;" v-html="$t('inputs.guestSearch.createNewGuestProfileWithName', { guestName: props.option[props.labelKey] })"></td>
        </tr>
      </table>
    </template>
    <template slot="icon-inline-left">
      <icon icon="search" />
    </template>
    <template slot="icon-inline-right">
      <input-icon-button v-tooltip="{ title: $t('inputs.guestSearch.unlinkGuestProfile'), delay: 0, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }"
                         :border="false"
                         :class="[{'transparent pointer-events-none': required || isEmpty(internalValue) || disabledCombined }]"
                         :disabled="disabledCombined"
                         icon="close-text"
                         @click="unlinkGuestProfile()" />
      <input-icon-button v-tooltip="{ title: $t('inputs.guestSearch.editGuestProfile'), delay: 250, placement: 'top', positionFixed: true, trigger: 'hover', touch: false }"
                         :border="true"
                         :disabled="isEmpty(internalValue)"
                         icon="edit"
                         @click="editGuestProfile()" />
    </template>
  </hm-select>
</template>

<script>

import { isNil, isArray, isObject, template, isString, isEmpty, find, debounce, trim, replace } from 'lodash';
import HmInputMixin from '@/mixins/HmInputMixin';
import HotelmeisterMixin from '../../../mixins/HotelmeisterMixin';

export default {
  name: 'GuestSearch',

  mixins: [HmInputMixin, HotelmeisterMixin],

  props: {
    required: {
      type: Boolean,
      required: false,
      default: false,
    },
    type: {
      type: String,
      default: 'Guest',
      validator: val => ['Guest', 'Company', 'TravelAgent', 'Other'].includes(val),
    },
  },

  data: function () {
    return {
    };
  },

  computed: {
  },


  watch: {
  },

  created: function () {
    this.$serviceBus.$on('help.input.show', this.showHelp);
  },

  methods: {
    onCreateOption: function (newOption) {
      this.axios.post(this.serviceUrls.guest.create(this, this.type), newOption.name || newOption.id, {
        headers: {
          'Content-Type': 'text/plain',
        },
      })
        .then((response) => {
          this.internalValue = response.data.data;
        })
        .catch((error) => {
          this.showMessages(error.response);
        });
    },
    showHelp: function () {
      if (!isNil(this.$refs) && !isNil(this.$refs.guestSearch) && this.$refs.guestSearch.hasFocus) {
        this.$driver.highlight(
          {
            element: this.$el,
            padding: 15,
            popover: {
              title: 'Gastsuche',
              description: 'Hier können Sie nach einem Gast suchen der bereits in Ihrer Gastekartei existiert.<br/><br/>Mit dem "X" können Sie die Gästeprofilverknüpfung aufheben.<br/><br/>Mit dem Stift-Symbol können Sie das Gästeprofil öffnen um z.B. andere Reservierungen dieses Gastes zu finden.',
              position: 'bottom-center',
            },
          },
        );
      }
    },
    isEmpty: function (val) {
      return isEmpty(val);
    },
    editGuestProfile: function () {
      this.$router.push({ name: 'guest', params: { guestProfileId: this.internalValue } });
    },
    updateValue: function (queryString = null) {
      this.$refs.guestSearch.updateValue(queryString, true);
    },
    unlinkGuestProfile: function () {
      this.internalValue = null;
      this.profile = {
        type: this.type,
        primaryAddress: {},
      };
    },
    optimizeAddress: function (address) {
      return replace(trim(address, ' \t\r\n,'), /[\s]+,/gm, ',');
    },
    isValidValue: function (arg) {
      if (isEmpty(arg)) return true;
      if (isObject(arg)) return true;
      if (isString(arg) && arg.match(/^tenant::[0-9]+::guest::[0-9]+$/gi)) return true;
      return false;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
</style>

<style lang="scss">
  @import '~styles/import';

  .td--gravatar {
    position: relative;
    width: 32px;
    max-width: 32px;
    min-width: 32px;

    @media (min-width: $br-tablet) {
      width: 64px;
      max-width: 64px;
      min-width: 64px;
    }

    &:before {
      content: ' ';
      display: block;
      margin-top: 100%;
    }

    &--empty {
      &:before {
        display: none!important;
        content: '';
      }
    }

    .gravatar {
      top: 50%;
      transform: translateY(-50%);
      position: relative;

      &__wrapper {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/lib/inputs/GuestSearch.vue